import { render } from "./ParamTile.vue?vue&type=template&id=95bec406"
import script from "./ParamTile.vue?vue&type=script&lang=js"
export * from "./ParamTile.vue?vue&type=script&lang=js"

import "./ParamTile.vue?vue&type=style&index=0&id=95bec406&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__